var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("这是用来测试的，康康！")])}
var staticRenderFns = []

export { render, staticRenderFns }